import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class MainGuard  {
  is_going: boolean = false;
  constructor(private _ds: DataService, private _user: UserService, private router: Router){
    // this.getSettings();
  }

   async canActivate() {
      await this.getSettings().then(res=>{
       this.is_going = true;
      }).catch(er=>{
        this.is_going = false;
      })
      if(this.is_going && this._user.getLoginState()){
        return true;
      }
      this.router.navigate(['login']);
    }


  async getSettings(): Promise<boolean>{
    return new Promise((resolved, rejects)=>{
      this._ds._httpRequest('getsettings', null, 5).subscribe((res: any)=>{
        res = this._user._decrypt(res.a);
        this._user.setLoading(false);
        this._user.setSettings(res.data);
        resolved(true);
      },er=>{
        rejects(false);
        this._user.setLoading(false);
      })
    })
  }


  // getSettings() {
  //   this._user.setLoading(true);
  //   this._ds._httpRequest('getsettings', null, 5).subscribe(
  //     (res: any) => {
  //       console.log('good acad year')
  //       res = this._user._decrypt(res.a);
  //       this._user.setSettings(res.data);
  //       this._user.setLoading(false);
  //       this.is_going = true;
        
  //     },
  //     (er) => {
  //       this._user.setLoading(false);
  //       console.log('invalid acad year')
  //       this.is_going = false;
  //     }
  //   );
    
  // }

  
}
